(function () {
    'use strict';

    var app = angular.module('intro-app');

    // Configure Toastr
    toastr.options.timeOut = 4000;
    toastr.options.positionClass = 'toast-bottom-right';

    // For use with the HotTowel-Angular-Breeze add-on that uses Breeze
    var remoteServiceName = 'breeze/Breeze';

    var events = {
        controllerActivateSuccess: 'controller.activateSuccess',
        spinnerToggle: 'spinner.toggle'
    };

    var config = {
        appErrorPrefix: '[OS] ', //Configure the exceptionHandler decorator
        docTitle: 'OS: ',
        events: events,
        remoteServiceName: remoteServiceName,
        version: '2.1.0'
    };

    app.value('config', config);

    app.config(['$logProvider', function ($logProvider) {
        // turn debugging off/on (no info or warn)
        if ($logProvider.debugEnabled) {
            $logProvider.debugEnabled(true);
        }
    }]);

    //#region Configure the common services via commonConfig
    app.config(['commonConfigProvider', function (cfg) {
        cfg.config.controllerActivateSuccessEvent = config.events.controllerActivateSuccess;
        cfg.config.spinnerToggleEvent = config.events.spinnerToggle;
    }]);
    //#endregion

    //#region translate
    app.config(['$translateProvider', function ($translateProvider) {
        $translateProvider.useStaticFilesLoader({
            prefix: '/intro-app/translations/translation_',
            suffix: '.json?version=4'
        })
        .registerAvailableLanguageKeys(['en', 'it'], {
            'en_*': 'en',
            'it_*': 'it',
            '*': 'it'
        })
        .determinePreferredLanguage()
        //.preferredLanguage('en')
        .fallbackLanguage('en');
        $translateProvider.useLocalStorage();
    }]);
    //#endregion

    app.config(function (tmhDynamicLocaleProvider) {
        tmhDynamicLocaleProvider.localeLocationPattern('/scripts/angular-locale_{{locale}}.js');
    });
})();